import { deepMemoized } from './helpers';
import { wrappedAnalytics } from './setConfiguration';
import { setProps } from './setProps';
let previousTrackingProps;
export function sendCommerce({
  name,
  data
}) {
  const formattedCommerceProps = deepMemoized({
    name,
    data
  });
  if (!previousTrackingProps || formattedCommerceProps !== previousTrackingProps) {
    previousTrackingProps = formattedCommerceProps;
    const {
      customObject,
      ...eventData
    } = data;
    if (customObject && Object.keys(customObject).length) {
      setProps(customObject, {
        events: [name]
      });
    }
    wrappedAnalytics.sendEvent(name, eventData);
  }
}